import { socketSend } from '@namespace/socket';

interface ISocketResponse<T> {
  data?: T;
  cid: string;
  ok: boolean;
}

interface ICasinoGames {
  id: string;
  order_by: number;
}

type GetFavoriteGamesDataType = Record<string, ICasinoGames[]>;

interface IFavoriteParams {
  entityName: string;
  id: string;
}

export const getFavoriteGames = (
  entityName: string
): Promise<ISocketResponse<GetFavoriteGamesDataType>> =>
  socketSend({
    cmd: `accounting/favorites/get_entities`,
    data: {
      entities: [entityName]
    }
  });

export const addGameToFavorites = ({
  entityName,
  id
}: IFavoriteParams): Promise<ISocketResponse<null>> => {
  return socketSend({
    cmd: 'accounting/favorites/save',
    data: {
      [entityName]: [{ id }]
    }
  });
};

export const removeGameFromFavorites = ({
  entityName,
  id
}: IFavoriteParams): Promise<ISocketResponse<null>> =>
  socketSend({
    cmd: 'accounting/favorites/delete',
    data: {
      [entityName]: [{ id }]
    }
  });
